// A company DLP filter (data-loss prevention: a browser extension or endpoint agent on the person's
// computer) refusing our request. It is not a fault of the app or the server — the fix is on that
// computer — so the person is told plainly and asked to have IT allow the chat. 2026-10-29: three
// unexplained «DLP has blocked outbound traffic containing sensitive data» reports from one Mac.
// Raised in the data worker (NetworkClient.raw → `dlpBlocked` worker event) and on the page
// (uncaught errors); the banner listens on the page.

const PATTERN = /\bDLP\b|blocked outbound traffic/i;

type Listener = () => void;
const listeners = new Set<Listener>();

export const DlpBlock = {
  matches(message: unknown): boolean {
    return typeof message === 'string' && PATTERN.test(message);
  },
  notify(): void {
    for (const l of listeners) l();
  },
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
};
